import {Matcher} from '@/lib/axiosAddTransforms'
import {invoiceResponse} from '@/transformers/matchers/invoices-issue'

const matchers: Matcher[] = [
  {
    test: /^\/external\/invoices\/\$id\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invoiceId} = payload.params
        payload.url = `/external/invoices/${invoiceId}`
        delete payload.headers.Authorization
        delete payload.params.invoiceId
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return externalInvoiceResponse(data)
      },
    },
  },
  {
    test: /^\/external\/invoice-review\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invoiceId} = payload.params
        payload.url = `/external/invoices/${invoiceId}/preview`
        delete payload.headers.Authorization
        delete payload.params.invoiceId
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
  {
    test: /^\/external\/invoice-review\/download\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invoiceId} = payload.params
        payload.url = `/external/invoices/${invoiceId}/download`
        delete payload.headers.Authorization
        delete payload.params.invoiceId
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
]

const externalInvoiceResponse = (data) => {
  const {virtualEvidences = [],} = data

  const {rawData} = virtualEvidences[0] || {}
  const {receiver, sender} = rawData || {}
  const response = invoiceResponse(data)
  delete response.clientSubEmail
  return {
    ...response,
    bizName: receiver.name,
    bizOwnerName: receiver.bossName,
    bizAddress: receiver.fullAddress,
    bizClass: receiver.businessClass,
    bizType: receiver.businessType,
    bizEmail: receiver.email,
    bizSubEmail: receiver.emailSub,
    bizNumber: receiver.bizRegistrationNumber,
    bizTaxNumber: receiver.taxRegistrationNumber,

    clientName: sender.name,
    clientOwnerName: sender.representativeName,
    clientAddress: sender.fullAddress,
    clientBizClass: sender.businessClass,
    clientBizType: sender.businessType,
    clientEmail: sender.email,
    clientBizNumber: sender.registrationNumber,
    clientTaxNumber: sender.taxRegistrationNumber,
  }
}

export default matchers
